const FlashCardsType = {
  SET_FLASHCARDS_LOADING: 'FLASHCARDS/SET_FLASHCARDS_LOADING',
  SET_FLASHCARDS_FAILURE: 'FLASHCARDS/SET_FLASHCARDS_FAILURE',
  SET_FLASHCARDS_SUCCESS: 'FLASHCARDS/SET_FLASHCARDS_SUCCESS',
};

export default FlashCardsType;